import { createSelector } from "@reduxjs/toolkit";
const selectCoupons = (state) => state.cart.coupons;
export const selectCouponCodes = createSelector([selectCoupons], (coupons) => coupons.map(({ code }) => code));
//# sourceMappingURL=selectCouponCodes.js.map